import "./sentry";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Link } from 'react-router-dom';
import { SpeedInsights } from "@vercel/speed-insights/react";
import Services from './pages/Services';
import Nav from './components/Nav';
import NotFound from './pages/Notfound';
import Contact from './pages/Contact';
import About from './pages/About';
import Team from './pages/Team';
import Reservations from './pages/Reservations';
import Footer from './components/Footer';
import TeamMember from './pages/TeamMember';
import Login from './pages/Login';
import HaircutGallery from './pages/Gallery.js';
import CookieConsent from 'react-cookie-consent';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import CookiePolicy from './pages/CookiePolicy.js';
import ReservationConflict from './pages/ReservationConflict.js';
import ReservationSuccess from './pages/ReservationSuccess.js';
import smoothscroll from 'smoothscroll-polyfill';
import FloatingCallButton from './components/FloatingCallButton';
import { SalonProvider } from './context/SalonContext';

smoothscroll.polyfill();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <SalonProvider>
    <Nav/>
    <Routes>
      <Route path='/' Component={App}></Route>
      <Route path='/services' Component={Services}></Route>
      <Route path='/contact' Component={Contact}></Route>
      <Route path='/about' Component={About}></Route>
      <Route path='/team' Component={Team}></Route>
      <Route path='/team/:id' Component={TeamMember}></Route>
      <Route path='/reservations' Component={Reservations}></Route>
      <Route path='/reservation-conflict' Component={ReservationConflict}></Route>
      <Route path='/reservation-success' Component={ReservationSuccess}></Route>
      <Route path='/login' Component={Login}></Route>
      <Route path='/gallery' Component={HaircutGallery}></Route>
      <Route path='/privacy-policy' Component={PrivacyPolicy}></Route>
      <Route path='/cookie-policy' Component={CookiePolicy}></Route>
      <Route path='*' Component={NotFound}></Route>
    </Routes>
    <Footer />

    <FloatingCallButton />
    <SpeedInsights />
    <CookieConsent
  location="bottom"
  buttonText="Приемам"
  declineButtonText="Отказвам"
  enableDeclineButton
  style={{
    background: "#2B373B",
    color: "#fff",
    zIndex: 2000,
    padding: "10px 20px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }}
  buttonStyle={{
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer",
  }}
  declineButtonStyle={{
    backgroundColor: "#dc3545",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer",
  }}
  expires={150}
>
  <span style={{ marginRight: "10px" }}>
    Този уебсайт използва бисквитки. Ако продължите да използвате сайта, вие се съгласявате с използването на бисквитки.{" "}
    <Link to="/cookie-policy" style={{ color: "#ffc107", textDecoration: "underline" }}>
      Научете повече
    </Link>
  </span>
</CookieConsent>

    </SalonProvider>
  </BrowserRouter>
);

reportWebVitals();
